module.exports = __webpack_public_path__ + "static/CA_CS-ee30fe59d41efa14fe46a4d3c4c04c4a.svg";